module.exports = __webpack_public_path__ + "media/images/element/contact-31a570b57d515593f6dcc84c0a5bc119.svg";